import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const RestoranReportPDF = ({ data, logos }) => (
  <Document>
    <Page size="A4" style={sharedStyles.page}>
      <View style={sharedStyles.header}>
        <View style={sharedStyles.businessInfo}>
          {logos.length > 0 && <View style={sharedStyles.logoContainer}>{logos.slice(0, 3).map((logo, index) => <Image key={index} src={logo.data} style={sharedStyles.logo} />)}</View>}
          <Text style={sharedStyles.businessName}>{data.restaurantName || 'Restaurant Name'}</Text>
          <Text style={sharedStyles.businessDetails}>Location: {data.location}</Text>
        </View>
        <View style={sharedStyles.documentTitle}>
          <Text style={sharedStyles.title}>Daily Sales & Profit Report</Text>
          <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
          <Text style={sharedStyles.documentInfo}>Report Date: {data.reportDate}</Text>
        </View>
      </View>
      <View style={sharedStyles.section}>
        <Text style={sharedStyles.sectionTitle}>Daily Sales</Text>
        <View style={sharedStyles.table}>
          <View style={sharedStyles.tableHeader}>
            <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>Item Name</Text>
            <Text style={sharedStyles.tableCellCenter}>Quantity</Text>
            <Text style={sharedStyles.tableCellRight}>Unit Price</Text>
            <Text style={sharedStyles.tableCellRight}>Total</Text>
          </View>
          {data.salesItems && data.salesItems.map((item, index) => (
            <View key={index} style={sharedStyles.tableRow}>
              <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>{item.itemName}</Text>
              <Text style={sharedStyles.tableCellCenter}>{item.quantity}</Text>
              <Text style={sharedStyles.tableCellRight}>${item.unitPrice.toFixed(2)}</Text>
              <Text style={sharedStyles.tableCellRight}>${item.total.toFixed(2)}</Text>
            </View>
          ))}
        </View>
      </View>
      <View style={sharedStyles.section}>
        <Text style={sharedStyles.sectionTitle}>Daily Expenses</Text>
        <View style={sharedStyles.table}>
          <View style={sharedStyles.tableHeader}>
            <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>Expense Item</Text>
            <Text style={sharedStyles.tableCellRight}>Amount</Text>
          </View>
          {data.expenses && data.expenses.map((expense, index) => (
            <View key={index} style={sharedStyles.tableRow}>
              <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>{expense.expenseItem}</Text>
              <Text style={sharedStyles.tableCellRight}>${expense.amount.toFixed(2)}</Text>
            </View>
          ))}
        </View>
      </View>
      <View style={sharedStyles.summary}>
        <View style={sharedStyles.summaryBox}>
          <View style={sharedStyles.summaryRow}><Text style={{ ...sharedStyles.summaryLabel, color: '#4CAF50' }}>Total Revenue:</Text><Text style={{ ...sharedStyles.summaryValue, color: '#4CAF50' }}>${data.totalRevenue?.toFixed(2) || '0.00'}</Text></View>
          <View style={sharedStyles.summaryRow}><Text style={{ ...sharedStyles.summaryLabel, color: '#f44336' }}>Total Expenses:</Text><Text style={{ ...sharedStyles.summaryValue, color: '#f44336' }}>${data.totalExpenses?.toFixed(2) || '0.00'}</Text></View>
          <View style={sharedStyles.summaryTotal}><Text style={sharedStyles.summaryTotalLabel}>Daily Profit:</Text><Text style={sharedStyles.summaryTotalValue}>${data.dailyProfit?.toFixed(2) || '0.00'}</Text></View>
        </View>
      </View>
      {data.notes && <View style={sharedStyles.notes}><Text style={sharedStyles.notesTitle}>Notes:</Text><Text style={sharedStyles.notesText}>{data.notes}</Text></View>}
      <View style={sharedStyles.footer}>
        <Text>© 2025 Software Development East Africa (SODEAF) — Innovating for a smarter Africa.</Text>
        <Text>Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | mohamedqadar280@gmail.com</Text>
      </View>
    </Page>
  </Document>
);

export default RestoranReportPDF;
